import PropTypes from 'prop-types';
import { attr, fk, Model } from 'redux-orm';

class PatientFamilyHistory extends Model {
  static modelName = 'PatientFamilyHistory';

  static fields = {
    id: attr(),
    diagnosis: attr(),
    relationship: attr(),
    comments: attr(),
    activeTill: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    updatedBy: fk('Client', 'familyHistoryChanger'),
    createdBy: fk('Client', 'familyHistoryCreator'),
    patientId: fk({
      to: 'Patient',
      as: 'patient',
      relatedName: 'familyHistories',
    }),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      diagnosis: PropTypes.string,
      relationship: PropTypes.number,
      comments: PropTypes.string,
      activeTill: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      updatedBy: PropTypes.number,
      createdBy: PropTypes.number,
      patientId: PropTypes.number,
    }),
    patientId: PropTypes.number,
  };
}

export default PatientFamilyHistory;
